import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// One route only — a run opens in a drawer over the queue, deep-linked via
// `?distributionId=`, so there is no separate detail path.
export const distributionRunsRoutes: RouteRecordRaw[] = [
  {
    path: routes.RENTAL_DISTRIBUTION_RUNS,
    name: 'RENTAL_DISTRIBUTION_RUNS',
    component: () => import('./RentalDistributionsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'view_properties',
      activeMenu: 'Rental Distribution',
    },
  },
]
